<script>
import Multiselect from "vue-multiselect";
import { authComputed } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import Middleware from "@/helpers/middlewares";
import InboxService from "@/helpers/APIService/inbox.service";
import errorHandler from "@/helpers/errorHandler";
export default {
  data() {
    return {
      lobbyGC: {
        group_name: null,
        group_tags: [],
      },
      submittedLobbyChat: false,
      isAddNewChat: false,
      tagsOptions: [],
    };
  },
  components: {
    Multiselect,
  },
  computed: {
    ...authComputed,
  },
  validations: {
    lobbyGC: {
      group_name: { required },
    },
  },
  mounted() {
    this.tagsOptions = JSON.parse(localStorage.getItem("thisChatData"));
  },
  methods: {
    async handleLobbyGCAdding(data) {
      this.submittedLobbyChat = true;

      // stop here if form is invalid
      this.$v.lobbyGC.$touch();
      if (this.$v.lobbyGC.$invalid) {
        return;
      } else {
        let tagz = [];
        data.group_tags.map((tag) => {
          tagz.push(tag.value);
        });
        let dataToAdd = {
          msg_content: data.message,
          group_name: data.group_name,
          group_tags: tagz,
          hotel: this.hotel.id,
          group_type: "common_lobby",
        };
        this.isAddNewChat = true;
        try {
          const response = await InboxService.addInboxGroups(dataToAdd);
          if (response) {
            this.isAddNewChat = false;
            Middleware.notification("Successfully updated !!", "success");
            this.$bvModal.hide("add-chat");
            this.lobbyGC.group_name = null;
            this.lobbyGC.group_tags = [];
            this.submittedLobbyChat = false;
            this.lobbyGC.message = "";
            this.$root.$emit("relaodPage");
          }
        } catch (error) {
          this.isAddNewChat = false;
          errorHandler(error);
        }
      }
    },
  },
};
</script>
<template>
  <b-tabs justified nav-class="nav-tabs-custom" content-class="pt-3">
    <b-tab active>
      <template v-slot:title>
        <span class="d-inline-block d-sm-none">
          <i class="fas fa-home"></i>
        </span>
        <span class="d-none d-sm-inline-block"> New Lobby Conversation </span>
      </template>
      <b-form-group class="mb-3">
        <label for="group_name"
          >Group Name <span class="text-danger">*</span></label
        >
        <b-form-input
          id="name-input"
          v-model.trim="lobbyGC.group_name"
          placeholder="Enter your group name"
          autocomplete="off"
          type="text"
          :class="{
            'is-invalid': submittedLobbyChat && $v.lobbyGC.group_name.$error,
          }"
        ></b-form-input>
        <div
          v-if="submittedLobbyChat && $v.lobbyGC.group_name.$error"
          class="invalid-feedback"
        >
          <span v-if="!$v.lobbyGC.group_name.required"
            >Group name is required.</span
          >
        </div>
      </b-form-group>
      <label> Tags </label>
      <Multiselect
        v-model="lobbyGC.group_tags"
        :options="tagsOptions"
        placeholder="Select tag/s"
        label="name"
        track-by="value"
        :show-labels="false"
        :multiple="true"
      ></Multiselect>
      <div class="row mt-2">
        <div class="col-md-12">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="
              () => {
                this.$root.$emit('cancelAddition', true);
              }
            "
            >Cancel
          </b-button>
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            @click="handleLobbyGCAdding(lobbyGC)"
            :class="{ disabled: isAddNewChat }"
          >
            <i
              v-if="isAddNewChat"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            Create
          </b-button>
        </div>
      </div>
    </b-tab>
  </b-tabs>
</template>
